import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Select from "../../../../helpers/ui/CustomSelect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";
import IndexBloc from "../Index/Blocs/IndexBloc";

var reformatOptions = function(raw, label, value) {
  return raw.map(function(data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();
  indexBloc = new IndexBloc();
  timer;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      employeeListOption: null,
      gradeListOption: null,
      positiontype:[
        {'label':'Definitif','value':1},
        {'label':'PLT','value':2}
      ],
      positionOption: null,
      isPLT: null,
      uuid: null,
      positiontypename: '',
      positiondefinitifuuid: '',
      positiondefinitifname: '',
    };
  }

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };
  handle_position = (uuid) => {
    this.createBloc.fetchPositionList({'uuid':uuid});
    // alert(uuid)
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.fetchEmployeeList();
    this.createBloc.fetchGradeList();
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.createBloc.employeeListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            employeeListOption: result.data?.response?.result,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.gradeListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            gradeListOption: result.data?.response?.result,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.positionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          console.log(result)
          this.setState({
            positionOption: reformatOptions(
              result.data?.response?.plt, 
              'position_name',
              'position_uuid'
          ),
          positiontypename: (result.data?.response && result.data?.response?.plt==0)?'Definitif':'',
          positiondefinitifuuid: result.data?.response?.definitif.position_uuid,
          positiondefinitifname: result.data?.response?.definitif.position_name,

          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.employeeListChannel?.unsubscribe();
    this.createBloc.gradeListChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody style={{ height: "500px" }}>
                  <div className="float-end">
                    <Link to={`/kepegawaian/mapping_tunjangan_khusus.html`}>
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Tambah Mapping Kelas Pegawai</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Pilih Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <Select
                          name="mapping_grade_tunsus_employee_uuid"
                          placeholder="Pilih Pegawai..."
                          errorMessage="Pilih Pegawai"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          options={this.state.employeeListOption}
                          optionLabel="employee_name"
                          optionValue="employee_uuid"
                          isLoading={!this.state.employeeListOption?.length}
                          onChange={
                            (v) => {
                              this.handle_position(v.employee_uuid)
                              // console.log(v.employee_uuid);
                            }
                        }
                        />
                      </Col>
                    </Row>
                    {
                      (this.state.positionOption && this.state.positionOption.length>0)?
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_employee_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Jenis Jabatan <span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <Select 
                                name={`positiontype`}
                                errorMessage="Pilih Jenis Jabatan"
                                options={this.state.positiontype} 
                                validate={{ required: { value: true } }}
                                placeholder="Pilih Jenis jabatan"
                                isLoading={this.state.positiontype}
                                onChange={
                                    (v) => {this.setState({
                                        isPLT: v.value
                                    })
                                    // alert(this.state.isPLT);
                                  }
                                }
                                // defaultValue={data.type}
                            />
                          </Col>
                        </Row>:
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_employee_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Jenis Jabatan <span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                          <AvField
                              name={`positiontype_name`}
                              placeholder="Pilih pegawai terlebih dahulu"
                              errorMessage="Pilih pegawai terlebih dahulu"
                              type="text"
                              readOnly={true}
                              className="form-control"
                              value={this.state.positiontypename}
                          // validate={{ required: { value: true } }}
                          />
                          <AvField
                              name={`positiontype`}
                              type="hidden"
                              value={1}
                          // validate={{ required: { value: true } }}
                          />
                          </Col>
                        </Row>

                    }
                    {
                      // (this.state.isPLT ==2)?
                      ((this.state.positionOption && this.state.positionOption.length>0) && this.state.isPLT == 2)?
                      <Row className="mb-3">
                        <label
                          htmlFor="mapping_grade_tunsus_employee_uuid"
                          className="col-md-3 col-form-label"
                        >
                          Jabatan <span className="text-danger">*</span>
                        </label>
                        <Col md="3">
                          <Select 
                              name={`positionuuid`}
                              errorMessage="Pilih Jabatan"
                              options={this.state.positionOption} 
                              validate={{ required: { value: true } }}
                              placeholder="Pilih jabatan"
                              isLoading={this.state.positionOption}
                              // onChange={
                              //     (v) => this.setState({
                              //         selectedEmployee: v.model
                              //     })
                              // }
                              // defaultValue={data.type}
                          />
                        </Col>
                      </Row>
                      :
                      <Row className="mb-3">
                        <label
                          htmlFor="mapping_grade_tunsus_employee_uuid"
                          className="col-md-3 col-form-label"
                        >
                          Jabatan <span className="text-danger">*</span>
                        </label>
                        <Col md="3">
                        <AvField
                              name={`position_name`}
                              placeholder="Pilih pegawai terlebih dahulu"
                              errorMessage="Pilih pegawai terlebih dahulu"
                              type="text"
                              readOnly={true}
                              className="form-control"
                              value={this.state.positiondefinitifname}
                          // validate={{ required: { value: true } }}
                          />
                          <AvField
                              name={`positionuuid`}
                              type="hidden"
                              value={this.state.positiondefinitifuuid}
                          // validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>
                    }

                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_special_level_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Pilihan Grade <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <Select
                          name="mapping_grade_tunsus_special_level_uuid"
                          placeholder="Pilihan Grade..."
                          errorMessage="Pilihan Grade"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          options={this.state.gradeListOption}
                          optionLabel="special_level_code"
                          optionValue="special_level_uuid"
                          isLoading={!this.state.gradeListOption?.length}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_special_level_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Berlaku Dari <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name={`mapping_grade_tunsus_start_date`}
                          type="date"
                          errorMessage="MasukkanTanggal Mulai Berlaku"
                          validate={{ required: { value: true } }}
                          placeholder="Tanggal Mulai Berlaku"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/mapping_tunjangan_khusus.html?" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
